export default {
  resourcesWithTag: 'Resources with this tag',
  resourcesDescription: 'Browse all resources associated with this tag'
};
